import { BirdviewRowRelativeTime } from '../BirdviewRowRelativeTime'
import { DashboardListRow } from '../DashboardListRow'

import AnnouncementIcon from '../../../icons/notification.svg'

function BirdviewAnnouncementRow({ item, onOpen }) {
  function handleOpen(event) {
    onOpen({ event, item })
  }

  return (
    <DashboardListRow
      Icon={AnnouncementIcon}
      Meta={BirdviewRowRelativeTime}
      actionKey='DashboardBirdview.RowActionReadKey'
      isUnread={item.unread}
      metaProps={{ date: item.published }}
      subtitle={item.address}
      title={item.title}
      onAction={handleOpen}
      onMouseDownTitle={handleOpen}
      onOpen={handleOpen}
    />
  )
}

export default BirdviewAnnouncementRow
